"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.proxyImage = void 0;
var config_1 = require("../config");
var createQueryString_1 = require("./createQueryString");
function proxyImage(url, width, height) {
    if (typeof url !== 'string')
        return url;
    var config = (0, config_1.getConfig)();
    var imageUrl = config.mxmAuxApiUrl + '/images/view';
    if (url.startsWith(imageUrl)) {
        return url;
    }
    if (!width && !height)
        height = 284;
    var query = (0, createQueryString_1.createQueryString)({ url: url, height: height, width: width });
    return "".concat(imageUrl, "?").concat(query);
}
exports.proxyImage = proxyImage;
